import { render } from "./DemandView.vue?vue&type=template&id=e4d62696"
import script from "./DemandView.vue?vue&type=script&lang=js"
export * from "./DemandView.vue?vue&type=script&lang=js"

import "./DemandView.vue?vue&type=style&index=0&id=e4d62696&lang=css"

import exportComponent from "/home/webcoom/Documents/www/esim-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__